<div class="home-container">
    <div class="about">
        @for (homeConfig of homeConfigList; track homeConfig) {
            <div class="newbooks-home">
                @if (homeConfig.active) {
                    <div>
                        @if (homeConfig.component === 'pf-home-info') {
                            <pf-home-info />
                        }
                        @if (homeConfig.component === 'pf-novelty-products') {
                            <pf-novelty-products />
                        }
                        @if (homeConfig.component === 'pf-discounted-products') {
                            <pf-discounted-product-offering />
                        }
                        @if (homeConfig.component === 'pf-discounted-packages') {
                            <pf-discounted-package-offering />
                        }
                        @if (homeConfig.component === 'pf-on-sale-products') {
                            <pf-on-sale-products />
                        }
                    </div>
                }
            </div>
        }
        <div class="blog-container">
            <div class="title-home-blog">
                <div class="title-home-blog-second">
                    <h3>{{ 'home.newsletterBlogs' | translate }}</h3>
                </div>
            </div>
            <div class="image-container">
                <pf-blog-slideshow [bannersBlogUrl]="bannerThumbUrl" [isBannerThumb]="true" />
            </div>
        </div>
    </div>
</div>
